<!-- Tour Top Header -->
<header class="tour-header">
  <div class="header-inner">
    <div class="header-titles">
      <span class="tour-badge">Self-Guided Audio & Visual Tour</span>
      <h1 class="tour-headline">Bayou Lacombe Museum Guide</h1>
    </div>
    <div class="header-actions">
      <a routerLink="/appointment" class="book-tour-btn">
        <mat-icon>calendar_today</mat-icon>
        <span>Docent Tour</span>
      </a>
    </div>
  </div>

  <!-- Progress Bar & Stop Indicator -->
  <div class="progress-section">
    <div class="progress-bar-container" role="progressbar" [attr.aria-valuenow]="progressPercentage" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar-fill" [style.width.%]="progressPercentage"></div>
    </div>
    <div class="progress-info">
      <span>Stop {{ currentStopIndex + 1 }} of {{ tourStops.length }}</span>
      <span>{{ progressPercentage }}% Completed</span>
    </div>
  </div>

  <!-- Horizontal Stop Quick Selector -->
  <nav class="stop-nav" aria-label="Tour Stops">
    <button 
      *ngFor="let stop of tourStops; let idx = index"
      type="button"
      class="stop-pill"
      [class.active]="currentStopIndex === idx"
      [class.completed]="idx < currentStopIndex"
      (click)="goToStop(idx)"
      [attr.aria-current]="currentStopIndex === idx ? 'step' : null">
      <span class="pill-number">{{ stop.id }}</span>
      <span class="pill-text">{{ stop.title }}</span>
    </button>
  </nav>
</header>

<main class="tour-main-content">
  <!-- Current Stop Showcase Card -->
  <article class="stop-card">
    <div class="stop-image-hero">
      <img [src]="currentStop.imageUrl" [alt]="currentStop.title" />
      <div class="image-gradient-overlay"></div>
      
      <div class="stop-floating-meta">
        <span class="category-chip">{{ currentStop.categoryLabel }}</span>
        <span class="location-chip">
          <mat-icon>place</mat-icon>
          {{ currentStop.location }}
        </span>
      </div>
    </div>

    <div class="stop-body">
      <!-- Title & Audio Narration Bar -->
      <div class="stop-title-bar">
        <div>
          <h2 class="stop-title">{{ currentStop.title }}</h2>
          <p class="stop-subtitle">{{ currentStop.subtitle }}</p>
        </div>

        <button 
          *ngIf="speechSynthesisSupported"
          type="button" 
          class="audio-narrate-btn" 
          [class.playing]="isAudioPlaying"
          (click)="toggleAudioNarration()"
          [attr.aria-label]="isAudioPlaying ? 'Pause audio narration' : 'Listen to audio narration'">
          <mat-icon>{{ isAudioPlaying ? 'pause_circle' : 'volume_up' }}</mat-icon>
          <span>{{ isAudioPlaying ? 'Pause Guide' : 'Listen to Audio' }}</span>
        </button>
      </div>

      <!-- Stop Narrative -->
      <div class="stop-story-block">
        <h3>Overview</h3>
        <p>{{ currentStop.description }}</p>
      </div>

      <div class="stop-story-block context-box">
        <h3>Historical Context</h3>
        <p>{{ currentStop.historicalContext }}</p>
      </div>

      <!-- What to Look For Checklist -->
      <div class="look-for-card">
        <h3>
          <mat-icon>visibility</mat-icon>
          What to Look For at this Stop:
        </h3>
        <ul class="look-for-list">
          <li *ngFor="let item of currentStop.lookFor">
            <mat-icon class="check-icon">check_circle</mat-icon>
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>

      <!-- Navigation Step Controls -->
      <footer class="stop-nav-controls">
        <button 
          type="button" 
          class="nav-step-btn prev"
          [disabled]="currentStopIndex === 0"
          (click)="previousStop()">
          <mat-icon>arrow_back</mat-icon>
          <span>Previous Stop</span>
        </button>

        <span class="stop-counter">{{ currentStopIndex + 1 }} / {{ tourStops.length }}</span>

        <button 
          type="button" 
          class="nav-step-btn next"
          [disabled]="currentStopIndex === tourStops.length - 1"
          (click)="nextStop()">
          <span>Next Stop</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </footer>
    </div>
  </article>

  <!-- Tour Footer Tips -->
  <aside class="tour-tips-container">
    <div class="tip-box">
      <mat-icon>photo_camera</mat-icon>
      <div>
        <h4>Photography Welcome</h4>
        <p>Personal photography is encouraged. Please tag &#64;BayouLacombeMuseum in your social shares!</p>
      </div>
    </div>
    <div class="tip-box">
      <mat-icon>accessible</mat-icon>
      <div>
        <h4>Accessibility & Comfort</h4>
        <p>Ground-level ramp access is available at the rear entrance. Benches are situated in the courtyard.</p>
      </div>
    </div>
  </aside>
</main>
